import React from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import value from './images/value.jpg'

const Valuation = () => {
    return (
        <>

            <div className="">
                <div className="py-6 ">
                    <div className="relative md:px-10 after:w-[100%] md:after:w-[94%]  baner">
                        <img src={value} alt="value" className='md:h-[70vh] h-[45vh]' />
                        <div className=" absolute top-0 bottom-0 z-10 w-full md:w-[56%] md:left-[21%]  ">
                            <div className="md:mx-10 mx-5 md:pt-5 ">
                                <div className="my-10"><h1 className='font-black text-[2.5rem]  tracking-wider text-white'>Valuations</h1>
                                    <h1 className='border-b-8 border-b-[#B5D1B3] w-[4rem]'></h1>
                                </div>
                                <div className="">
                                    <p className='tracking-wider leading-8 text-white text-[1rem] md:text-[1.5rem] font-bold'>Led by LAWD's founding partner and respected valuations specialist, Tim McKinnon, our fully accredited team offers industry-leading experience and expertise in conducting complex valuations for some of Australia's most significant real estate assets</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text">
                    <div className="md:w-[56%] w-full  md:mx-[18rem] py-8">
                        <p className='py-10 mx-4 md:mx-0 leading-7 tracking-wide'>We operate across agricultural sectors with an office network that spans the country, and pride ourselves on our reputation for excellence, trust, reliability, and results.</p>
                        <p className='leading-7 md:mx-0 mx-4 tracking-wide'>Our team of agribusiness professionals is complemented by quality assurance processes, robust governance systems and world-class technologies. We value collaboration, with all reports peer-reviewed to ensure they are of the highest standard and deliver the optimal outcome.</p>
                        <p className='py-10 leading-7 md:mx-0 mx-4 tracking-wide'>We build authentic partnerships and relationships with our clients and maintain deep connections to institutional and corporate investors to ensure our valuations professionals are well-informed with real-time market intelligence.</p>

                        <button className='border tracking-wider md:mx-0 mx-4 border-[#004a8b] text-[#004a8b] px-5 py-3 text-[13px] hover:border-[#B5D1B3] hover:bg-[#B5D1B3] hover:text-[black]'>CONTACT OUR TEAMS</button>
                    </div>

                    <div className="">
                        <div className="flex md:mx-[17rem] pb-10 pt-[4rem]">
                            <button>
                                <Link to='/TranServices' className='text-[#004a8b] flex'>< FaArrowLeft className='text-[#B5D1B3] font-black text-[1.6rem] w-[100%] mx-5'/><h1 className='my-1 text-[12px] font-black tracking-widest'>TRANSACTION</h1></Link>
                            </button>
                            <h1 className='text-[10px]font-bold md:block hidden md:mx-[13rem] w-[11%] text-center justify-center border-b-2 border-[#004a8b] tracking-wider text-[#004a8b] '>
                            <span className='text-[12px] font-black'>VALUATION</span>
                            </h1>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Valuation